export enum ProfessionalTitle {
  PR = 'PR',
  DR = 'DR',
  MR = 'MR',
  MRS = 'MRS',
}

export const professionalTitleMapping = {
  [ProfessionalTitle.PR]: $localize`:@@common_professionalTitle_pr:Pr`,
  [ProfessionalTitle.DR]: $localize`:@@common_professionalTitle_dr:Dr`,
  [ProfessionalTitle.MR]: $localize`:@@common_professionalTitle_mr:Mr`,
  [ProfessionalTitle.MRS]: $localize`:@@common_professionalTitle_mrs:Mrs`,
};
